var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('iframe',{staticClass:"map-iframe",attrs:{"src":_vm.mapSrc,"allowfullscreen":""}}),_c('Footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }